export default "__VITE_ASSET__BzTZqMRT__"